module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp@2/3471/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_iter-step.js
// module id = 115
// module chunks = 0